import { EditTodoIcon } from '@/assets/icons/info-icons/editTodo';
import { getInvestorEntityType } from '@/components/transactions-page/generateSignaturePacket-page/details';
import { IInvestorDetailsStepForm } from '@/components/transactions-page/generateSignaturePacket-page/steps/investorDetails';
import { useResponsive } from '@/hooks/use-responsive';
import { themeVar } from '@/styles/theme';
import { Eligibility } from '@trace-8/trace8-schema';
import styled from 'styled-components';

interface DocumentationDetailsProps {
  documentationDetailsData: (IInvestorDetailsStepForm & { id: string }) | null;
  openInvestorDetailsPage: () => void;
}

const getEligibilityValue = (eligibility: (keyof typeof Eligibility)[]): string => {
  if (!eligibility.length) return '--';

  const orderedEligibility = Object.keys(Eligibility) as (keyof typeof Eligibility)[];

  for (const key of orderedEligibility) {
    if (eligibility.includes(key as keyof typeof Eligibility)) {
      return Eligibility[key as keyof typeof Eligibility];
    }
  }

  return '--';
};

export const DocumentationDetails = ({ documentationDetailsData, openInvestorDetailsPage }: DocumentationDetailsProps) => {
  const { isMobile } = useResponsive();

  return (
    <DocumentationDetailsWrapper isMobile={isMobile}>
      <Card isMobile={isMobile}>
        <CardTitle>TAX STATUS</CardTitle>
        <CardDesc>{documentationDetailsData?.taxStatus}</CardDesc>
      </Card>
      <Card isMobile={isMobile}>
        <CardTitle>ENTITY TYPE</CardTitle>
        <CardDesc>{getInvestorEntityType(documentationDetailsData?.entityType, documentationDetailsData?.otherType)}</CardDesc>
      </Card>
      <Card isMobile={isMobile}>
        <CardTitle>ELIGIBILITY</CardTitle>
        <CardDesc>{getEligibilityValue(documentationDetailsData?.eligibility ?? [])}</CardDesc>
      </Card>
      <Card short isMobile={isMobile} onClick={openInvestorDetailsPage}>
        <EditTodoIcon width={30} height={24} fill={themeVar('font.action')} />
      </Card>
    </DocumentationDetailsWrapper>
  );
};

const DocumentationDetailsWrapper = styled.div<{ isMobile: boolean }>`
  background-color: ${themeVar('layer.1')};
  color: ${themeVar('font.base')};
  display: flex;
  align-items: center;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  gap: 10px;
  border-bottom: 1px solid ${themeVar('border.base')};
  padding: 20px 16px 16px;
  @media (min-width: 600px) {
    padding: 20px 50px 50px;
  }
`;

const Card = styled.div<{ short?: boolean; isMobile: boolean }>`
  display: flex;
  cursor: ${({ short }) => (short ? 'pointer' : 'default')};
  width: ${({ short, isMobile }) => (isMobile ? '100%' : short ? '7%' : '31%')};
  min-width: 80px;
  height: 80px;
  min-height: 80px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: ${themeVar('layer.base')};
  border-radius: 10px;
`;

const CardTitle = styled.div`
  color: ${themeVar('font.weak')};
  font-family: Blinker;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 22.4px;
`;

const CardDesc = styled.div`
  color: ${themeVar('font.strong')};
  font-family: Blinker;
  font-size: 23px;
  font-style: normal;
  font-weight: 700;
  line-height: 32.3px;
`;
